<template>
  <div class="sidebar" data-color="brown" data-active-color="danger">
    <div class="logo">
      <a href="/dashboard/main" class="simple-text logo-mini">
        <div class="logo-image-small">
          <img
            src="../../assets/img/me_logo.png"
            style="max-width: 100%; opacity: 1"
          />
        </div>
      </a>
      <a href="/dashboard/main" class="simple-text logo-normal">
        Modern-Expo
      </a>
    </div>
    <div class="sidebar-wrapper">
      <div class="user">
        <div class="photo">
          <!--<img v-if="typeof photo == 'undefined' && !photo" :src="photo" style="width: 130% !important; max-width: 125% !important;"/>
                  <img v-else src="../../assets/img/logo-small.png" style="width: 130% !important; max-width: 125% !important;"/>-->
          <img
            :src="$store.getters.getProfilePhoto"
            style="width: 130% !important; max-width: 125% !important"
          />
        </div>
        <div class="info">
          <a data-toggle="collapse" href="#collapseExample" class="collapsed">
            <span>
              {{ name }}
              <b class="caret"></b>
            </span>
          </a>
          <div class="clearfix"></div>
          <div class="collapse" id="collapseExample">
            <ul class="nav">
              <li>
                <router-link :to="{ name: 'profile' }">
                  <span class="sidebar-mini-icon">MP</span>
                  <span class="sidebar-normal">My Profile</span>
                </router-link>
              </li>
              <!--<li>
                                <a href="#">
                                    <span class="sidebar-mini-icon">EP</span>
                                    <span class="sidebar-normal">Edit Profile</span>
                                </a>
                            </li>-->
              <!--<li>
                                <a href="#">
                                    <span class="sidebar-mini-icon">S</span>
                                    <span class="sidebar-normal">Settings</span>
                                </a>
                            </li>-->
            </ul>
          </div>
        </div>
      </div>
      <ul class="nav">
        <li :class="{ active: isActive('/dashboard/main') }">
          <router-link :to="{ name: 'dashboard' }">
            <i class="nc-icon nc-chart-pie-36"></i>
            <p>{{ $t("menu.dashboard") }}</p>
          </router-link>
        </li>
        <li v-if="role.production || role.admin">
          <a data-toggle="collapse" href="#drawing">
            <i class="nc-icon nc-ruler-pencil"></i>
            <p>
              {{ $t("menu.drawing") }}
              <b class="caret"></b>
            </p>
          </a>
          <div class="collapse" id="drawing">
            <ul class="nav">
              <li
                v-if="role.production || role.admin"
                :class="{ active: isActive('/dashboard/drawing/main') }"
              >
                <router-link :to="{ name: 'drawing-main' }">
                  <span class="sidebar-mini-icon">S</span>
                  <span class="sidebar-normal">{{
                    $t("menu.drawing-structure")
                  }}</span>
                </router-link>
              </li>
              <li
                v-if="role.production || role.admin"
                :class="{ active: isActive('/dashboard/drawing/article') }"
              >
                <router-link :to="{ name: 'drawing-article' }">
                  <span class="sidebar-mini-icon">A</span>
                  <span class="sidebar-normal">{{
                    $t("menu.drawing-article")
                  }}</span>
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <!--<li>
                    <a data-toggle="collapse" href="#pagesExamples">
                        <i class="nc-icon nc-book-bookmark"></i>
                        <p>
                            Documents
                            <b class="caret"></b>
                        </p>
                    </a>
                    <div class="collapse " id="pagesExamples">
                        <ul class="nav">
                            <li>
                                <router-link :to="{ name: 'monitoring-order'}">
                                    <span class="sidebar-mini-icon">L</span>
                                    <span class="sidebar-normal"> Monitoring order </span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </li>-->
        <li v-if="role.manager || role.admin">
          <a data-toggle="collapse" href="#report">
            <i class="nc-icon nc-paper"></i>
            <p>
              {{ $t("menu.report") }}
              <b class="caret"></b>
            </p>
          </a>
          <div class="collapse" id="report">
            <ul class="nav">
              <li>
                <router-link :to="{ name: 'monitoring-order' }">
                  <span class="sidebar-mini-icon">M</span>
                  <span class="sidebar-normal">
                    {{ $t("menu.monitoring-order") }}
                  </span>
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <li v-if="role.production || role.admin">
          <a data-toggle="collapse" href="#monitoring">
            <i class="nc-icon nc-tv-2"></i>
            <p>
              {{ $t("menu.monitoring") }}
              <b class="caret"></b>
            </p>
          </a>
          <div class="collapse" id="monitoring">
            <ul class="nav">
              <li>
                <a href="#">
                  <span class="sidebar-mini-icon">RF</span>
                  <span class="sidebar-normal"> ME </span>
                </a>
              </li>
              <li>
                <a href="#">
                  <span class="sidebar-mini-icon">EF</span>
                  <span class="sidebar-normal"> VZPR </span>
                </a>
              </li>
              <li>
                <a href="#">
                  <span class="sidebar-mini-icon">V</span>
                  <span class="sidebar-normal"> Vitebsk </span>
                </a>
              </li>
              <li>
                <a href="#">
                  <span class="sidebar-mini-icon">W</span>
                  <span class="sidebar-normal"> S </span>
                </a>
              </li>
            </ul>
          </div>
        </li>
        <!--<li :class="{'active': isActive('/dashboard/calendar')}">
                    <router-link :to="{ name: 'calendar'}">
                        <i class="nc-icon nc-calendar-60"></i>
                        <p>Calendar</p>
                    </router-link>
                </li>-->
        <li :class="{ active: isActive('/dashboard/about') }">
          <router-link :to="{ name: 'about' }">
            <i class="nc-icon nc-book-bookmark"></i>
            <p>{{ $t("menu.about") }}</p>
          </router-link>
        </li>

        <li>
          <a @click="logout">
            <i class="nc-icon nc-user-run"></i>
            <p>{{ $t("menu.logout") }}</p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "SideBar",
  data() {
    return {
      role: {
        user: false,
        manager: false,
        production: false,
        monitoring: false,
        personal: false,
        admin: false,
        custom: false,
        officer: false,
      },
      name: "",
      photo: "",
    };
  },
  mounted() {
    this.name = localStorage.getItem("name");
    this.photo = "data:image/png;base64," + localStorage.getItem("photo");

    let listRole = localStorage.getItem("role");
    if (listRole.indexOf("user") >= 0) {
      this.role.user = true;
    }
    if (listRole.indexOf("manager") >= 0) {
      this.role.manager = true;
    }
    if (listRole.indexOf("production") >= 0) {
      this.role.production = true;
    }
    if (listRole.indexOf("monitoring") >= 0) {
      this.role.monitoring = true;
    }
    if (listRole.indexOf("personal") >= 0) {
      this.role.personal = true;
    }
    if (listRole.indexOf("admin") >= 0) {
      this.role.admin = true;
    }
    if (listRole.indexOf("custom") >= 0) {
      this.role.custom = true;
    }
    if (listRole.indexOf("officer") >= 0) {
      this.role.officer = true;
    }
  },
  methods: {
    isActive(input) {
      //console.log(input)
      const paths = Array.isArray(input) ? input : [input];
      return paths.some((path) => {
        console.log(path);
        console.log(this.$route.path.indexOf(path));
        return this.$route.path.indexOf(path) === 0; // current path starts with this path string
      });
    },

    logout: function () {
      localStorage.removeItem("user-token");
      localStorage.removeItem("ip");
      localStorage.removeItem("name");
      localStorage.removeItem("role");
      localStorage.removeItem("user");
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SidebarPlugin/SideBar.vue